// eslint-disable-next-line react/react-in-jsx-scope
import React from 'react';
import GameRulesText from '../../components/InfoButton/GameRulesText';

const RulesOfTheGame = () => (
  <>
    <p style={{ color: 'darkslategray' }}>
      <GameRulesText game="find" />
    </p>
  </>
);

export default RulesOfTheGame;
